import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLeftLong, faPlus, faRightLong } from "@fortawesome/free-solid-svg-icons";
import PropTypes from "prop-types";
import "./styles.css";

export default function CarouselControls({
  onPrev,
  onNext,
  onAdd,
  isPrevDisabled,
  isNextDisabled,
}) {
  return (
    <div className="carousel-controls">
      <button
        className="carousel-button"
        onClick={onPrev}
        disabled={isPrevDisabled}
      >
        <FontAwesomeIcon icon={faLeftLong} />
      </button>
      <button
        className="carousel-button"
        onClick={onAdd}
      >
        <FontAwesomeIcon icon={faPlus} />
      </button>
      <button
        className="carousel-button"
        onClick={onNext}
        disabled={isNextDisabled}
      >
        <FontAwesomeIcon icon={faRightLong} />
      </button>
    </div>
  );
}

CarouselControls.propTypes = {
  onPrev: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
  isPrevDisabled: PropTypes.bool,
  isNextDisabled: PropTypes.bool,
};

CarouselControls.defaultProps = {
  isPrevDisabled: false,
  isNextDisabled: false,
};
